import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { RiCheckboxCircleFill } from '@remixicon/react';
import { useNavigate } from 'react-router-dom';

function PricingSuccessScreen() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Container className="py-5">
            <Row className="mb-5">
                <Col xs={12} className="text-center">
                    <div className="mb-4">
                        <RiCheckboxCircleFill size={64} />
                    </div>
                    <h2 className="title mb-2">{t('pricing.success.title')}</h2>
                    <p className="subtitle">{t('pricing.success.subtitle')}</p>
                </Col>
            </Row>

            <Row className="mb-5">
                <Col xs={12} md={8} className="mx-auto">
                    <Card>
                        <Card.Body>
                            <h4 className="mb-3 fw-bold">{t('pricing.success.nextSteps')}</h4>
                            <ul className="list-unstyled">
                                <li className="d-flex align-items-start mb-3">
                                    <RiCheckboxCircleFill size={20} className="me-3 mt-1 flex-shrink-0" />
                                    <span>{t('pricing.success.step1')}</span>
                                </li>
                                <li className="d-flex align-items-start mb-3">
                                    <RiCheckboxCircleFill size={20} className="me-3 mt-1 flex-shrink-0" />
                                    <span>{t('pricing.success.step2')}</span>
                                </li>
                                <li className="d-flex align-items-start">
                                    <RiCheckboxCircleFill size={20} className="me-3 mt-1 flex-shrink-0" />
                                    <span>{t('pricing.success.step3')}</span>
                                </li>
                            </ul>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col xs={12} className="text-center">
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={() => navigate('/')}
                        className="me-3"
                    >
                        {t('pricing.success.goToApp')}
                    </Button>
                    <Button
                        variant="outline-primary"
                        size="lg"
                        onClick={() => navigate('/user/subscriptions')}
                    >
                        {t('pricing.success.viewMySubscription')}
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}

export default PricingSuccessScreen;
